import React, {useState} from "react";
import { useEffect } from "react";
import ComparatorHistorical from "./ComparatorHistorical";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/es'; 

const date = moment();

const firstColumn = {
    title: {
        title: 'Productos Seleccionados',
        id: null,
        details: null
    },
    resumen: {
        title: 'Resumen',
        rentabilidadPeriodo: 'Rentabilidad Periodo',
        inversionMinima: 'Inversión mínima',
        riesgo: 'Riesgo'
    },
    rentabilidades: {
        title: 'Rentabilidades por años',
        actualYear: date.year(),
        oneYear: '1 año',
        threeYears: '3 años'
    },
    histórico: {
        title: 'Histórico'
    }
}

// const historico = [
//     {
//         name: 'Enero',
//         value: 114,
//         value2: 116
//     },
//     {
//         name: 'Febrero',
//         value: 230,
//         value2: 701
//     },
//     {
//         name: 'Marzo',
//         value: 112,
//         value2: 1153
//     },
//     {
//         name: 'Abril',
//         value: 240,
//         value2: 750
//     },
//     {
//         name: 'Mayo',
//         value: 131,
//         value2: 145
//     },
//     {
//         name: 'Junio',
//         value: 211,
//         value2: 532
//     }
// ];

// const data = [
//     {
//       name: 'Diario',
//       value: -0.01,
//       value2: -0.02
//     },
//     {
//       name: 'Semana',
//       value: -0.05,
//       value2: -0.06
//     },
//     {
//       name: 'Mes',
//       value: -7.38,
//       value2: -6.45
//     },
//     {
//       name: '3 meses',
//       value: -7.5,
//       value2: -6
//     },
//     {
//       name: '6 meses',
//       value: -8.02,
//       value2: -7
//     },
//     {
//       name: 'YTD',
//       value: 14.18,
//       value2: 13
//     }
// ];

// const optionsData = [
//     {
//         value: 'fondos',
//         label: 'Fondos de inversión'
//     },
//     {
//         value: 'sicav',
//         label: 'SICAV Luxemburgo'
//     },
//     {
//         value: 'planesPensiones',
//         label: 'Planes de pensiones'
//     },
//     {
//         value: 'epvs',
//         label: 'EPSVS'
//     },
//     {
//         value: 'ASOCIADO',
//         label: 'Planes Asociados'
//     },
//     {
//         value: 'planosEmpleo',
//         label: 'Planes de empleo'
//     }
// ];

const ComparatorResults = ({
    comparatorSlot1,
    comparatorSlot2,
    comparatorSlot3,
    comparatorSlot4,
    clickAddComparatorButton,
}) => {
    const [ tableColumns, setTableColumns ] = useState([firstColumn]);
    const colors = [
        '#cc0000','#e59d27', '#abc111', '#1bb3bc', '#9e3667', '#fecc09'
    ];
    const navigate = useNavigate();

    useEffect(() => {
        setTableColumns([
            firstColumn,
            comparatorSlot1,
            comparatorSlot2,
            comparatorSlot3,
            comparatorSlot4
        ])
    }, [comparatorSlot1, comparatorSlot2, comparatorSlot3, comparatorSlot4])

    return (
        <section className="container">
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 20}}>
                <span className="blueText" style={{fontWeight: 600, fontSize: 16, marginBottom: 20}}>Detalle de la comparativa (máx. 4 productos)</span>
                {/* <span style={{fontSize: '14px', fontWeight: 500, color: 'red'}}>
                    <span style={{marginRight: 30}}><i className="fa fa-2x fa-file-pdf-o" style={{marginRight: 5, fontSize: 20}}></i> Exportar</span>
                    <span><i className="fa-solid fa-2x fa-print" style={{marginRight: 5, fontSize: 20}}></i> Imprimir</span>
                </span> */}
            </div>
            { /* Productos seleccionados */ }
            <div style={{display: 'flex'}}>
                {
                    tableColumns?.map((e, idx) =>
                        <div
                            key={idx}
                            className="button-box"
                            style={{maxWidth: 'inherit',
                                    margin: 0,
                                    width: '100%',
                                    height: 150,
                                    borderLeft: idx > 0 ? 0 : '1px solid rgba(245,245,245, 1)',
                                    textAlign: 'left',
                                    display:'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'left',
                                    cursor: 'default',
                                    borderBottom: e && e.title?.details ? '20px solid '+colors[idx-1] : ''
                                }}>
                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%'}}>
                                {
                                    e ?
                                        <div>
                                            <div style={{fontWeight: e && e.title?.title !== 'Productos Seleccionados' ? 700 : 500}}>
                                                {e && e.title?.title}
                                            </div>
                                            <div style={{marginTop: 5, marginBottom: 5}}>{e && e.title?.id}</div>
                                            {
                                                e && e.title?.details &&
                                                <div style={{color: 'red', cursor: 'pointer'}} onClick={() => {
                                                    navigate(`/id/${e.title?.id}`);
                                                }}>Ver detalle</div>
                                            }
                                        </div>
                                        :
                                        <div style={{textAlign: 'center', width: '100%', justifyContent: 'center', display: 'flex', flexDirection: 'row'}}>
                                            <div style={{border: '1px solid red', width: 100, borderRadius: 15, color: 'red', fontWeight: 600, cursor: 'pointer'}}
                                                onClick={() => {clickAddComparatorButton(idx)}}>
                                                Añadir
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    )
                }
            </div>
            {/* Resumen */}
            <div className="comparatorTableDivider">
                {tableColumns[0]?.resumen?.title}
            </div>
            {
                Object.values(tableColumns[0]?.resumen).map((e, idx) =>
                    idx > 0 &&
                    <div key={idx} style={{display: 'flex'}}>
                        {
                            tableColumns?.map((i, id) =>
                                <div
                                    key={id + idx}
                                    className="button-box"
                                    style={{maxWidth: 'inherit',
                                            margin: 0,
                                            width: '100%',
                                            height: 100,
                                            borderLeft: id > 0 ? 0 : '1px solid rgba(245,245,245, 1)',
                                            textAlign: 'left',
                                            display:'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'left',
                                            cursor: 'default'
                                        }}>
                                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <div>
                                            {
                                                i &&
                                                (e === 'Rentabilidad Periodo' ?
                                                    Object.values(i.resumen)[idx] ?? + '-' + '%'
                                                    : e === 'Riesgo' && id > 0 ?
                                                        <div>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 0 ? 'fa-solid fa-circle circleRiesgoVerde' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 1 ? 'fa-solid fa-circle circleRiesgoVerde' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 2 ? 'fa-solid fa-circle circleRiesgoNaranja' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 3 ? 'fa-solid fa-circle circleRiesgoNaranja' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 4 ? 'fa-solid fa-circle circleRiesgoNaranja' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 5 ? 'fa-solid fa-circle circleRiesgoRojo' : 'fa-solid fa-circle circleRiesgo'}></i>
                                                            <i className={parseInt(Object.values(i.resumen)[idx]) > 6 ? 'fa-solid fa-circle circleRiesgoRojo' : 'fa-solid fa-circle circleRiesgo'} style={{marginRight: 5}}></i>
                                                            {Object.values(i.resumen)[idx]}/7
                                                        </div>
                                                        : Object.values(i.resumen)[idx]
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
            {/* Rentabilidad por años */}
            <div className="comparatorTableDivider">
                {tableColumns[0]?.rentabilidades.title}
            </div>
            {
                Object.values(tableColumns[0]?.rentabilidades).map((e, idx) =>
                    idx > 0 &&
                    <div key={idx} style={{display: 'flex'}}>
                        {
                            tableColumns?.map((i, id) =>
                                <div
                                    key={id}
                                    className="button-box"
                                    style={{maxWidth: 'inherit',
                                            margin: 0,
                                            width: '100%',
                                            height: 100,
                                            borderLeft: id > 0 ? 0 : '1px solid rgba(245,245,245, 1)',
                                            textAlign: 'left',
                                            display:'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'left'
                                        }}>
                                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <div>
                                            {i && Object.values(i.rentabilidades)[idx]}
                                            {i && id > 0 &&
                                            <span>
                                                % {
                                                    parseInt(Object.values(i.rentabilidades)[idx]) > 0 ?
                                                    <i className="fa-solid fa-arrow-up" style={{marginLeft: 10, fontSize: 20, color: 'green'}}></i>
                                                    :
                                                    <i className="fa-solid fa-arrow-down" style={{marginLeft: 10, fontSize: 20, color: 'red'}}></i>
                                                }
                                            </span>}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
            {/* Histórico */}
            <div className="comparatorTableDivider">
                {tableColumns[0]?.histórico.title}
            </div>
            {/* <div style={{marginTop: 10, marginBottom: 10}}>
                Fecha de última valoración: 09/12/2022
            </div> */}
            {/* <div>
                <Select
                    className='redArrowDown'
                    defaultValue="Filtrar por fecha WIP"
                    style={{ width: '100%', outline: '0px', maxWidth: '200px', marginRight: 40}}
                    loading={false}
                    options={optionsData}
                    showArrow={false}
                    onSelect={(e) => console.log(e)}
                    bordered={false}
                />
                Octubre 2019 - Diciembre 2020 <i style={{color: 'red', marginLeft: 10}} className="fa-solid fa-x"></i>
            </div> */}
            {/* <div style={{textAlign: 'right', fontSize: 16, marginBottom: 15}}>
                <span onClick={() => setShowGraph(true)} style={{color: showGraph ? 'red' : 'black', marginRight: 10, cursor: 'pointer'}}>Ver gráfica <i className="fa-solid fa-chart-simple"></i></span>
                <span onClick={() => setShowGraph(false)} style={{color: showGraph ? 'black' : 'red', cursor: 'pointer'}}>Ver lista <i className="fa-solid fa-list"></i></span>
            </div> */}
            <ComparatorHistorical
                comparatorSlot1={comparatorSlot1}
                comparatorSlot2={comparatorSlot2}
                comparatorSlot3={comparatorSlot3}
                comparatorSlot4={comparatorSlot4}
            />
        </section>
    );
};

export default ComparatorResults;
